/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-10-30 11:23:02
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-08 10:25:31
 * @FilePath: \sea-page-game\src\config\languages\id-ID.js
 */
module.exports = {
    message: {
        // 首页
        navigator_website: 'Situs',
        navigator_collect: 'Kumpulkan',
        navigator_service: 'CS',
        navigator_teach: 'Instruksi',
        navigator_logout: 'Keluar',
        navigator_mobile_logout: 'Mobile Login',
        navigator_email_logout: 'Email',
        navigator_download: 'Unduh',
        // 登录、注册页
        navigator_signIn: 'Daftar',
        navigator_lang: 'Login',
        navigator_email: 'Email',
        input_account: 'Masukan Akun',
        input_mobile: 'Masukan Nomor HP',
        input_password: 'Masukkan kata sandi',
        input_password_again: 'Konfirmasi Sandi',
        input_email_address: 'Masukkan Alamat Email',
        input_reset_email: 'Masukkan Akun/Email yang perlu direset kata sandi',
        input_reset_password: ', reset kata sandi dengan metode verifikasi berikut',
        retrieve_password: 'Ambil Kata Sandi',
        forget_password: 'Lupa Kata Sandi',
        next_step: 'Berikutnya',
        bind_email: 'Ikat Email',
        input_bind_email: 'Masukkan akun Email yang terikat',
        bound_email: 'Email Telah Ikat',
        enter_code: 'Masukan Kode Verifikasi',
        get_code: 'Kirim Kode',
        get_code_seconds: 's',
        security_verification: 'Verifikasi Keamanan',
        inputTheAnswer: 'Masukan Kode Verifikasi',
        noneSelectArea: "Pilih Kode Area",
        confirm: 'Konfirmasi',
        bind: 'Hubungkan',
        agree: 'Baca dan Setuju',
        tips_1: 'Nomor yang tidak terdaftar akan didaftarkan dan masuk setelah verifikasi',
        copy_success: 'Salin Berhasil',
        copy_fail: 'Silakan salin secara manual',
        incorrect_email: 'Silahkan masukkan format email yang benar!',
        emailTips1: 'Kata sandi tidak boleh berisi spasi atau karakter Tionghoa!',
        emailTips2: 'Kata sandi minimal harus terdiri dari 6 digit',
        emailTips3: 'Dua kata sandi tidak konsisten',
        emailTips4: 'Kode verifikasi salah',
        emailTips5: 'Masukkan nama akun alfanumerik 4-12 digit',
        emailTips6: 'Masukkan kata sandi dengan kombinasi 6~20 karakter alfanumerik dan karakter khusus non-Tionghua',
        emailTips7: 'Dua kata sandi tidak konsisten',
        selectAreaCode: 'Kode Area',
        urlError: 'Alamat akses saat ini salah!',
        tips: 'Pengingat',
        verifiedTips1:'Anda harus berusia 18 tahun ke atas untuk memainkan game ini',
        verifiedTips2:'Login gagal, perlu selesaikan verifikasi identitas bisa main game',

        // 底部
        rules_clause: 'Komitmen Privasi',
        privacy_clause: 'Syarat Penggunaan',
        service_email: 'CS Email:',
        EmailAddress: 'maplestoryr.sea@gmail.com',
        // 教程页
        infoTitle: 'PC Login dan Tutorial Top up'
    }
}